/*
 * @创建文件时间: 2019-11-03 13:37:19
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-21 11:15:01
 * @联系Qq:1638245306
 * @文件介绍: 联调改IP地址
 */

function isopen() {
    // return (( new Date().getTime() - new Date("2022/12/26 00:00:00").getTime() ) > 0 )
    return false
}

class DebugUrl {
    constructor(debug, ip) {
        this._initial(debug, ip);
    }
    get api() {
        return this._api
    }
    get mapurl() {
        return this._mapip
    }
    _initial(isDebug, ip) {
        if (isDebug) {
            this._api = 'http://117.157.231.103:5002'
                // this._api = 'http://127.0.0.1:5002' //本地环境
            this._mapip = 'http://117.157.231.103'
        } else {
            // 生产环境
            this._api = isopen() ? 'https://api-zhyh.gsgl.org.cn' : 'http://117.157.231.103:5002' //正式服务器 https://api-zhyh.gsgl.org.cn
            this._mapip = 'http://117.157.231.103'
        }
    }

}
const isDebug = process.env.NODE_ENV !== 'production'
    // const isDebug = true
const ip = 0

const url = new DebugUrl(isDebug, ip)
export const baseUrl = url.api
export const mapIp = url.mapurl